import { type ReactNode, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { type IDropdownProps } from 'shared/ui'
import { IS_CALLING_APP_LIGHT } from 'shared/config'
import { DeviceItemsEnum, type DeviceSettingsStore } from 'entities/DeviceSettings/store'
import { DefaultInboxContent } from 'entities/DeviceSettings/ui/DeviceSettingsContent/DefaultInboxContent'
import styles from './styles.module.scss'
import { VideoInputContent } from './VideoInputContent'
import { AudioOutputContent } from './AudioOutputContent'
import { AudioInputContent } from './AudioInputContent'
import { RecordAutoContent } from './RecordAutoContent'
import { InboxSelectorContent } from './InboxSelectorContent'

export enum DeviceSettingsVariantEnum {
  dropdown = 'dropdown',
  container = 'container',
  modal = 'modal',
}

export type IDeviceSettingsContentProps = {
  parentsDropdownId?: string[]
  deviceSettingsStore: DeviceSettingsStore
  testOutputDevice?: () => void
  variant?: DeviceSettingsVariantEnum
  dropdownProps?: IDropdownProps
  exclude?: DeviceItemsEnum[]
}

export const DeviceSettingsContent: FC<IDeviceSettingsContentProps> = observer((props) => {
  const { deviceSettingsStore, variant = DeviceSettingsVariantEnum.dropdown, exclude = [] } = props
  const { loading, items } = deviceSettingsStore
  const { defaultInboxStore } = deviceSettingsStore

  const handleOpenInboxSelect = () => {
    defaultInboxStore?.loadInboxes()
    deviceSettingsStore.openInboxSelector()
  }

  if (IS_CALLING_APP_LIGHT && deviceSettingsStore.isInboxSelectorOpen && defaultInboxStore) {
    return (
      <InboxSelectorContent
        defaultInboxStore={defaultInboxStore}
        onBack={deviceSettingsStore.closeInboxSelector}
      />
    )
  }

  const obj: {
    [key in DeviceItemsEnum]: ReactNode
  } = {
    [DeviceItemsEnum.audioInput]: <AudioInputContent key={DeviceItemsEnum.audioInput} {...props} />,
    [DeviceItemsEnum.videoInput]: <VideoInputContent key={DeviceItemsEnum.videoInput} {...props} />,
    [DeviceItemsEnum.audioOutput]: (
      <AudioOutputContent key={DeviceItemsEnum.audioOutput} {...props} />
    ),
    [DeviceItemsEnum.recordAuto]: <RecordAutoContent key={DeviceItemsEnum.recordAuto} {...props} />,
    [DeviceItemsEnum.defaultInbox]: defaultInboxStore ? (
      <DefaultInboxContent
        key={DeviceItemsEnum.defaultInbox}
        defaultInboxStore={defaultInboxStore}
        onOpenInboxSelect={handleOpenInboxSelect}
        {...props}
      />
    ) : null,
  }

  return (
    <div
      className={classnames(styles.content, styles[variant], {
        [styles.loading]: loading,
      })}
    >
      {items.map((item) => {
        if (exclude.includes(item)) return null

        return obj[item]
      })}
    </div>
  )
})
